import Home from "components/Pages/Home";
import WorkingWithTheAPI from "components/Pages/WorkingWithTheAPI";
import Warmup from "components/Pages/Warmup";
import DisplayFullInfo from "components/Pages/DisplayFullInfo";
import SearchBooksAPI from "components/Pages/SearchBooksAPI";

// Constants
const routes = [
    {
        label: 'Home',
        path: '/',
        exact: true,
        element: <Home />,
    },
    {
        label: 'Warmup',
        path: '/warmup',
        element: <Warmup />,
    },
    {
        label: 'Working with the api',
        path: '/working-with-the-api',
        element: <WorkingWithTheAPI />,
        exact: true,
        sub: [
            {
                label: 'Single book',
                path: '/working-with-the-api/display-full-info',
                element: <DisplayFullInfo />,
                exact: true,
            },
            {
                label: 'Search API',
                path: '/working-with-the-api/search-api',
                element: <SearchBooksAPI />,
                exact: true
            }
        ]
    },
]

export default routes;